<div class="chip" *ngIf="expiration;else alternativeTextTemplate">
  <label *ngIf="!expired || featureFlags.retentionPolicyJobActive">{{getExpiringPrefix()}}&nbsp;</label><label>{{getExpiration()}}</label>
</div>
<ng-template #alternativeTextTemplate>
  <p class="chip-alt-text" *ngIf="alternativeText">{{alternativeText}}</p>
</ng-template>
